import React from 'react';

import { isDefined } from '@nfctron/nexus-core';

import { type AtomComponent } from '@root/lib/types/components';

import { useCartStoreCtx } from '../../stores/cartStore';

import { TicketsViewWithImportGoOutContentAtom } from './TicketsViewWithImportGoOutContent.atom';
import { TicketsViewWithImportNfctronTicketsContentAtom } from './TicketsViewWithImportNfctronTicketsContent.atom';

/**
 * Event/Cart/TicketsViewWithImportContent atom component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const TicketsViewWithImportContentAtom: AtomComponent = () => {
	const cartStoreCtx = useCartStoreCtx();
	const { importProviders } = cartStoreCtx.useCartConfig();

	return (
		<React.Fragment>
			{/* NFCtron physical/partner tickets top-up integration */}
			{isDefined(importProviders.nfctron) && <TicketsViewWithImportNfctronTicketsContentAtom nfctronTicketsConfig={importProviders.nfctron} />}
			{/* GoOut import integration */}
			{isDefined(importProviders.goout) && <TicketsViewWithImportGoOutContentAtom gooutConfig={importProviders.goout} />}
			{/* TODO: Ticketmaster, Boom Events import integrations */}
		</React.Fragment>
	);
};

/**
 * Event/Cart/TicketsViewWithImportContentAtom atom display name
 * @type {ComponentDisplayName<"atom">>}
 */
TicketsViewWithImportContentAtom.displayName = 'Event/Cart/TicketsViewWithImportContentAtom';
